import html2pdf from 'html2pdf.js';
import { PDFDocument, PDFData } from 'pdf-lib';
import axios from 'axios';
import { endpoints } from '../../../api/Config';


export const PrintAllSlipInOne = async  (packingSlipDocBody, shippingLabel, returnLabel) =>{
    try {
        
       
        const proxyUrl = `${endpoints.baseURL}proxy/pdf?url=`;
        const requests = [axios.get(`${proxyUrl}${encodeURIComponent(shippingLabel)}`, { responseType: 'arraybuffer' })];
        if (returnLabel) {
          requests.push(axios.get(`${proxyUrl}${encodeURIComponent(returnLabel)}`, { responseType: 'arraybuffer' }));
        }
         
       
        const responses = await Promise.all(requests);
        const labelPdf = responses[0];
        const returnPdf = returnLabel ? responses[1] : null;

        const labelPdfData = await PDFDocument.load(labelPdf.data);
        const returnPdfData = returnPdf ? await PDFDocument.load(returnPdf.data) : null;
      
       
        
        const mergedPdf = await PDFDocument.create();
        
        
       
      
        const slipPdf = await convertDocumentBodyToPdf(packingSlipDocBody);
    
        
        
        const slipPdfData = await PDFDocument.load(slipPdf);
        const slipPagesCount = slipPdfData.getPageCount() ;

    const slipPdfPages = await mergedPdf.copyPages(slipPdfData, Array.from({ length: slipPagesCount }, (_, i) => i));
    
    slipPdfPages.forEach((page) => mergedPdf.addPage(page));
    
    const labelPagesCount = labelPdfData.getPageCount();
  
    const firstPdf = await mergedPdf.copyPages(labelPdfData, Array.from({ length: labelPagesCount }, (_, i) => i));
    firstPdf.forEach((page) => mergedPdf.addPage(page));

    if (returnPdfData) {
      const returnPagesCount = returnPdfData.getPageCount();
      const secondPdf = await mergedPdf.copyPages(returnPdfData, Array.from({ length: returnPagesCount }, (_, i) => i));
      secondPdf.forEach((page) => mergedPdf.addPage(page));
    }
        

        const mergedPdfBytes = await mergedPdf.save();
        
        const pdfBlob = new Blob([mergedPdfBytes], { type: 'application/pdf' });

       
        const pdfUrl = URL.createObjectURL(pdfBlob);

       // Create an anchor element and trigger the download
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = '3x_Shipping_Labels.pdf'; // Set the download file name
    document.body.appendChild(link); // Append to the body to make it clickable
    link.click(); // Trigger the download
    document.body.removeChild(link); // Clean up by removing the element

        const printWindow = window.open(pdfUrl);

        // Print the document in the new window
        if (printWindow) {
          printWindow.onload = () => {
            printWindow.print();
          };
        } else {
          throw new Error('Unable to open a new window to print the PDF.');
        }
    
      } catch (error) {
        console.error('Error:', error);
      }
};
const convertDocumentBodyToPdf = async (body) => {
    try {
       
        
        const options = {
            filename: 'document.pdf', // Set the filename
            html2canvas: { scale: 2 }, // Adjust scale if needed
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' } // Set PDF format and orientation
        };

        
        const pdfBytes = await html2pdf().from(body).set(options).outputPdf('arraybuffer');
       
        return pdfBytes;
      } catch (error) {
        console.error('Error:', error);
      }
};

